import React from 'react';

import { faExclamationCircle, faPlus } from '@fortawesome/pro-solid-svg-icons';

import EmptyState from 'shared/empty_state';
import LoadingSpinner from 'components/ui/loading_spinner';
import Task from '../task';
import { useTasks } from '../context/tasks_context';

interface Props {
  taskClassName?: string;
}

export function TasksList({ taskClassName }: Props) {
  const {
    addTaskAttachment,
    currentParent,
    deleteTask,
    features,
    hideAssignees,
    loading,
    paths,
    removeTaskAttachment,
    selectedTask,
    showModal,
    showParents,
    showTaskModal,
    tasks,
    updateTask,
  } = useTasks();

  if (loading) {
    return <LoadingSpinner />;
  } else if (tasks.length === 0) {
    return <TasksEmptyState />;
  } else {
    return <>
      {tasks.map(task => (
        <Task
          active={task.id === selectedTask?.id && showModal}
          addTaskAttachment={addTaskAttachment}
          attachmentsPath={paths.attachments}
          className={taskClassName}
          currentParent={currentParent}
          deleteTaskAttachment={removeTaskAttachment}
          features={features}
          hideAssignee={hideAssignees}
          key={task.id}
          modalOpen={showModal}
          showParents={showParents}
          task={task}
          onClick={showTaskModal}
          onDelete={deleteTask}
          onUpdate={updateTask}
        />
      ))}
    </>;
  }
}

export function TasksEmptyState() {
  const { paths, showTaskModal } = useTasks();

  return (
    <EmptyState
      bodyText={
        paths.create
          ? 'Create your first task to get started'
          : 'Tasks created via Contacts, Deals or Listings will populate here'
      }
      buttonIcon={faPlus}
      buttonText="New Task"
      header="No tasks to display"
      icon={faExclamationCircle}
      plainButton={false}
      onClick={paths.create ? () => showTaskModal() : undefined}
    />
  );
}
